import React from "react";
import { useQuery } from "@apollo/client";
import { DecisionDetail } from "./decision-detail";
import { CasesSendReportDecisionDetailContainerSendReportCaseV1Document, CasesSendReportDecisionDetailContainerSendReportCaseV1CaseDetailsFieldsFragment } from "../../../../../../generated";
import { ComponentQueryLoader } from "../../../../../shared/component-query-loader";

interface DecisionDetailContainerProps {
  caseId: string;
}

export const DecisionDetailContainer: React.FC<DecisionDetailContainerProps> = (props) => {
  const {
    data: caseDecisionData,
    loading: caseDecisionLoading,
    error: caseDecisionError,
  } = useQuery(
    CasesSendReportDecisionDetailContainerSendReportCaseV1Document,
    {
      variables: {
        sendReportCaseV1Id: props?.caseId,
      },
      context: {
        headers: {
          "cache-enabled": "true",
        },
      },
    }
  );

  return (
    <ComponentQueryLoader
      loading={caseDecisionLoading}
      hasData={caseDecisionData}
      error={caseDecisionError}
      hasDataComponent={
        <DecisionDetail
          data={
            caseDecisionData?.sendReportCaseV1?.caseDetails as CasesSendReportDecisionDetailContainerSendReportCaseV1CaseDetailsFieldsFragment
          }
        />
      }
    />
  );
};
